import api from './api'

class SystemService {
    async getInstance() {
        return api.get('/system')
    }
}

export default new SystemService();
